import React from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import DatePickerContainer from 'routes/App/reports/ReportsPageDatepickerModule/styles';
import {SELF_DELIVERY_INVOICES_PERIOD_OPTIONS} from 'helpers/constants/reports';

// Charge-date period for the Self Delivery Invoices report; mirrors the "Time period" control.
const SelfDeliveryInvoicesPeriodPicker = ({value, onChange}) => (
  <DatePickerContainer>
    <span>Charge date</span>
    <div className='Say2EatDrop'>
      <FormControl variant='outlined'>
        <Select
          id='self-delivery-invoices-period'
          value={value}
          onChange={(event) => onChange(event.target.value)}
          MenuProps={{
            anchorOrigin: {vertical: 'bottom', horizontal: 'left'},
            transformOrigin: {vertical: 'top', horizontal: 'left'},
            getContentAnchorEl: null
          }}
        >
          {SELF_DELIVERY_INVOICES_PERIOD_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value} disableRipple>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  </DatePickerContainer>
);

SelfDeliveryInvoicesPeriodPicker.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
};

export default SelfDeliveryInvoicesPeriodPicker;
